import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icon.d.ts').IconMinus}
 */
const IconMinus = () => {
    return (
        <svg
            aria-hidden='true'
            fill='none'
            height='32'
            viewBox='0 0 20 20'
            width='32'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M3.83398 10.3327V9.66602H16.1673V10.3327H3.83398Z'
                fill='currentColor' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default IconMinus;
